import { nanoid } from 'nanoid';
import React from 'react';

interface Props {
  extensions: string[];
}

export const AttachFileNoteColumn = ({ extensions }: Props) => {
  return (
    <div className="column">
      {extensions.map((extension) => (
        <p key={nanoid()}>{extension}</p>
      ))}
    </div>
  );
};
